export const vehicleTypeMap = {
  vehicle: 'Легковой',
  car: 'Легковой',
  truck: 'Грузовик',
  lighttruck: 'Лёгкий грузовик',
  bus: 'Автобус',
  van: 'Фургон',
  pickuptruck: 'Пикап',
  suvmpv: 'Внедорожник / минивэн',
  buggy: 'Багги',
  unknown: 'Неизвестно',
  nonmotorvehicle: 'Немоторное ТС',
}

export const vehicleTypeColor = {
  vehicle: 'primary',
  car: 'primary',
  truck: 'warning',
  lighttruck: 'warning',
  bus: 'info',
  van: 'default',
  pickuptruck: 'default',
  suvmpv: 'default',
  buggy: 'default',
  unknown: 'default',
  nonmotorvehicle: 'secondary',
}

export const getVehicleTypeLabel = (raw, t) => {
  if (!raw) return '—'
  const key = String(raw).toLowerCase()
  return (t ? t(key) : null) || vehicleTypeMap[key] || String(raw)
}

export const getVehicleTypeChipProps = (raw, t) => {
  if (!raw) return { label: '—', color: 'default' }
  const key = String(raw).toLowerCase()
  return {
    label: (t ? t(key) : null) || vehicleTypeMap[key] || String(raw),
    color: vehicleTypeColor[key] || 'default'
  }
}

export const formatEventVehicleDimensions = (event) => {
  const fmt = (v) => (v ? `${Math.round(v / 10) / 100} м` : '—')
  return `Д: ${fmt(event?.vehicle_length_mm)}, Ш: ${fmt(
    event?.vehicle_width_mm
  )}, В: ${fmt(event?.vehicle_height_mm)}`
}
